import { Container, Link } from "basis";
import { useEventTracking } from "react-event-tracker";
import styles from "./accountLinkCard.module.scss";

function AccountLinkCard({ header, body }) {
  const { trackEvent } = useEventTracking();
  return (
    <div className={styles.card} data-trackid="account-link-card">
      <div className={styles.header}>
        <h2 className="h4">{header}</h2>
        <div className={styles.stack} />
      </div>
      <div className={styles.body}>
        <span>{body}</span>
        <Container margin="6 0 0 0">
          <Link
            appearance="primary-button"
            href="/link-account"
            newTab={false}
            onClick={() => {
              trackEvent({
                event: {
                  category: "text-link",
                  action: "in-page-navigation",
                  location: header,
                  label: "Link an account",
                },
              });
            }}
          >
            Link an account
          </Link>
        </Container>
      </div>
    </div>
  );
}

export { AccountLinkCard };
